module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX 打包体积过大")]), _vm._v(" "), _c('p', [_vm._v("一般是以下原因导致的：")]), _vm._v(" "), _c('h2', [_vm._v("import 语法使用问题")]), _vm._v(" "), _c('p', [_vm._v("在 "), _c('code', [_vm._v("vux-loader@1.0.61")]), _vm._v(" 以下版本，如果你在 "), _c('code', [_vm._v("import")]), _vm._v(" 和 "), _c('code', [_vm._v("{")]), _vm._v(" 之前没有空格，将不会被解析成按需引入的，比如：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v("{Group, Cell} "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("如果是这一情况，纠正或者升级到 vux-loader >= 1.0.61 可解决。")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("建议开启 "), _c('code', [_vm._v("eslint")]), _vm._v(" 来避免这一情况，即使 "), _c('code', [_vm._v("vux-loader")]), _vm._v(" 支持，更严格的编码规范利于开发维护。")])]), _vm._v(" "), _c('h2', [_vm._v("没有正确配置 vux-loader")]), _vm._v(" "), _c('p', [_vm._v("参照文档配置或者使用 "), _c('code', [_vm._v("airyland/vux2")]), _vm._v(" 模板。")]), _vm._v(" "), _c('h2', [_vm._v("不标准的写法")]), _vm._v(" "), _c('p', [_vm._v("vux-loader 基于代码文本替换实现按需引入，可能有部分奇怪的写法导致不能正确解析。可以建个 repo 联系作者解决。")]), _vm._v(" "), _c('p', [_vm._v("同时强烈推荐开启 eslint 保证编码质量。")]), _vm._v(" "), _c('h2', [_vm._v("注释里有 import 语句")]), _vm._v(" "), _c('p', [_vm._v("在 "), _c('code', [_vm._v("vux-loader@1.0.67")]), _vm._v(" 以下版本，如果存在单行注释里有从 VUX 引入组件会导致出现问题。请升级到最新。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eea90122", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-eea90122"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vux-build-issue-22.vue
// module id = 3042
// module chunks = 211